export default __webpack_public_path__ + "static/media/rounded-flag-2x.56dde5e5.webp";